import React, { useState } from 'react';
import { useGetDta } from '../../hooks/useGetDta';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TblHRouters, headTbl } from '../../data/tables';
import Table from '../Table';
import Confirmation from '../ui/Confirmation';
import classNames from 'classnames';
import ModRouter from './ModRouter';
import { NavLink } from 'react-router-dom';
import LoadinSpin from '../ui/LoadinSpin';
import DropDownsCol from '../ui/DropDownsCol';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import { ModRepair } from './ModRepair';
import { ModMoroso } from './ModMoroso';
import { getInitialColumns } from '../../data/cards';

const TblRouters = ({ allows }) => {
    const { loading, data, getInfo } = useGetDta(`networks/mktik`);

    const initialColums = getInitialColumns('mktik', TblHRouters);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums , 'mktik');


    const {r_add,
        r_edit,
        r_del,
        r_rep,
        r_chk, } = allows;
    const [show, setShow] = useState(false);
    const [showr, setShowr] = useState(false);
    const [id, setid] = useState();
    const [showm, setShowm] = useState(false);
    const [idm, setidm] = useState();

    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});

    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge', {
                        'bg-success': row.original.estado === 'CONECTADO',
                        'bg-danger': row.original.estado === 'DESCONECTADO',
                    })}>
                    {row.original.estado}
                </span>
            </>
        );
    };
    const CliColumn = ({ row }) => {
        return (
            <>
                <span className={`badge  bg-primary text-white ms-1 fs-6`}>{row.original.clie}</span>
            </>
        );
    };
    const SusColumn = ({ row }) => {
        return <span className={`badge  bg-danger text-white ms-1 fs-6`}>{row.original.susp}</span>;
    };
    if (loading) return <LoadinSpin />;

    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    {r_edit && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                            <NavLink to={`/admin/router/${btoa(`${row.original.id}`)}`}>
                                <i className="mdi mdi-pencil mdi-18px "></i>
                            </NavLink>
                        </OverlayTrigger>
                    )}

                    {r_del && (
                        <>
                            {row.original.clie === 0 ? (
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="overlay-example"> Borrar </Tooltip>}>
                                    <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id)}></i>
                                </OverlayTrigger>
                            ) : (
                                <OverlayTrigger
                                    placement="left"
                                    overlay={
                                        <Tooltip id="overlay-example">
                                            {' '}
                                            No se puede eliminar- Clientes conectados{' '}
                                        </Tooltip>
                                    }>
                                    <i className="mdi mdi-delete-off mdi-18px text-danger "></i>
                                </OverlayTrigger>
                            )}
                        </>
                    )}
                    {r_chk &&   <OverlayTrigger
                                className="action-icon "
                                placement="left"
                                overlay={<Tooltip id="overlay-example">Verificar Morosos</Tooltip>}>
                                <i
                                    className="mdi mdi-account-tie-voice-off mdi-18px text-success mx-1"
                                    onClick={() => moroso(row.original.id)}></i>
                            </OverlayTrigger>}

                    {r_rep  && (
                            <OverlayTrigger
                                className="action-icon "
                                placement="left"
                                overlay={<Tooltip id="overlay-example">Reparar router</Tooltip>}>
                                <i
                                    className="mdi mdi-vector-difference-ba mdi-18px text-warning"
                                    onClick={() => repair(row.original.id)}></i>
                            </OverlayTrigger>
                    )}
                </>
            </>
        );
    };

    const moroso = (idr) => {
        setidm(idr);
        setShowm(true);
    };
    const repair = (idr) => {
        setid(idr);
        setShowr(true);
    };

    const columns = [
        {
            Header: 'Id',
            accessor: 'id',
            sort: true,
        },
        {
            Header: 'Nombre',
            accessor: 'nodo',
            sort: true,
        },
        {
            Header: 'Ip',
            accessor: 'ip',
            sort: true,
        },
        {
            Header: 'Modelo',
            accessor: 'modelo',
            sort: true,
        },
        {
            Header: 'Versión',
            accessor: 'version',
            sort: true,
        },
        {
            Header: 'Clientes',
            accessor: 'clie',
            sort: true,
            Cell: CliColumn,
        },
        {
            Header: 'Suspendidos',
            accessor: 'susp',
            sort: true,
            Cell: SusColumn,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: StatusColumn,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id) => {
        setInfo({ id, type: 'SERVER' });
        setShowd(true);
    };

    return (
        <div>
            <h4 className="header-title mb-2">Routers</h4>

            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
                columnasVisibles={columnasVisibles}
                customButton={
                    r_add && (
                        <Button type="button" onClick={() => setShow(true)}>
                            <b>+</b> Nuevo
                        </Button>
                    )
                }
                visiblesCustum={
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                }
            />
            <ModRouter show={show} onHide={() => setShow(false)} size="lg" callBk={getInfo} />
            <ModRepair show={showr} funClose={() => setShowr(false)} id={id} />
            <ModMoroso show={showm} funClose={() => setShowm(false)} id={idm} />

            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};
export default TblRouters;
